import { RefObject } from 'react';
import { Button, Grid, Tooltip } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import once from 'lodash/once';
import { spinner } from '@/components';

const { useBreakpoint } = Grid;
const importJsPDF = once(() => import('jspdf'));
const importHtml2canvas = once(() => import('html2canvas'));

type PropsType = {
  pdfRef: RefObject<HTMLDivElement>;
};

export const ButtonDownloadStatisticPdf = ({ pdfRef }: PropsType) => {
  const screens = useBreakpoint();
  const isDesktopScreen = screens.xl;

  const downloadPdf = async () => {
    const { jsPDF } = await importJsPDF();
    const { default: html2canvas } = await importHtml2canvas();

    const statisticDiv = pdfRef.current as HTMLElement;
    spinner.show();
    try {
      const canvas = await html2canvas(statisticDiv, { scale: 2 });
      const imgData = canvas.toDataURL('image/jpeg');
      const pdf = new jsPDF('l', 'mm', 'a4', true);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgX = (pdfWidth - imgWidth * ratio) / 2;
      const imgY = 5;
      pdf.addImage(imgData, 'JPEG', imgX, imgY, imgWidth * ratio, imgHeight * ratio - imgY);
      pdf.save('Statistic.pdf');
    } finally {
      spinner.hide();
    }
  };

  return (
    <>
      {isDesktopScreen ? (
        <Tooltip placement="left" title="Save dashboard as PDF">
          <Button icon={<DownloadOutlined />} type="default" onClick={downloadPdf}>
            Download
          </Button>
        </Tooltip>
      ) : null}
    </>
  );
};
